




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { fixedHtmlData, ContainerDimensions } from "@/services/posts/postTypes/fixedhtml";
import { BehaviorEnum } from "@/services/posts/types";
@Component
export default class ImageSubComponent extends Vue {
    @Prop() containerDimensions!: ContainerDimensions;
    @Prop() localProperties!: fixedHtmlData;

    // Watch

    @Watch("localProperties.src", { immediate: true }) imageSourceChanged() {
        this.loadImage();
    }

    @Watch("localProperties.position", { immediate: true, deep: true }) imageAdjustChanged() {
        this.setDisplayImageStyle();
    }

    @Watch("localProperties.behavior", { immediate: true }) behaviorChanged() {
        this.setDisplayImageStyle();
    }

    // load cropper when media container dimensions changes
    @Watch("containerDimensions", { immediate: true, deep: true }) containerDimensionsChanged() {
        this.loadImage();
    }

    // - Data Properties -
    imageStyle: string = "";

    // Image manipulation properties
    ratio = 1;
    factor = 1;

    // Image dimensions
    img = {
        width: 0,
        height: 0
    };

    // Computed
    get src() {
        return this.localProperties.src || this.generatePlaceholderImage();
    }

    // Lifecycle Hooks
    mounted() {
        this.$emit("setDuration", 0);
    }

    generatePlaceholderImage() {
        return "https://placehold.jp/" + this.containerDimensions.width + "x" + this.containerDimensions.height + ".png";
    }

    // Methods
    loadImage() {
        const image = new Image();
        image.onload = () => {
            // For placeholder use channel width and height because it will always have same width and height.
            if (this.localProperties.src) {
                this.img.width = image.width;
                this.img.height = image.height;
            } else {
                this.img.width = this.containerDimensions.width;
                this.img.height = this.containerDimensions.height;
            }
            this.setDisplayImageStyle();
        };
        image.src = this.src;
    }

    setDisplayImageStyle() {
        this.imageStyle = "";

        if (this.localProperties.position) {
            const mediaDimensionsProperties = this.localProperties.position;
            const ratio = Math.max(this.containerDimensions.width / this.img.width, this.containerDimensions.height / this.img.height);
            this.ratio = ratio;
            if (this.localProperties.behavior === BehaviorEnum.adjust) {
                const ratio2 = Math.max((this.containerDimensions.width * mediaDimensionsProperties.factor) / mediaDimensionsProperties.cropSizeWidth, (this.containerDimensions.height * mediaDimensionsProperties.factor) / mediaDimensionsProperties.cropSizeHeight);
                this.imageStyle = `
                    transform: scale(${ratio * ratio2});
                    margin-left: ${-(mediaDimensionsProperties.x) * ratio2}px;
                    margin-top: ${-(mediaDimensionsProperties.y) * ratio2}px;
                `;
            } else if (this.localProperties.behavior === BehaviorEnum.crop) {
                if (this.ratio < 1) this.imageStyle = `transform: scale(${this.ratio}) translate(-50%, -50%)`;
            } else if (this.localProperties.behavior === BehaviorEnum.letterBox) {
                if (this.img.width > this.containerDimensions.width || this.img.height > this.containerDimensions.height) {
                    const ratio = Math.min(this.containerDimensions.width / this.img.width, this.containerDimensions.height / this.img.height);
                    this.imageStyle = `
                        width: ${this.img.width * ratio}px;
                        height: ${this.img.height * ratio}px;
                    `;
                }
            }
        }
    }
}
